module.exports = __webpack_public_path__ + "img/weedheads-rectangle.67815d62.png";